import(/* webpackMode: "eager" */ "/workspace/app/views/academics/components/AcademicCards.jsx");
import(/* webpackMode: "eager" */ "/workspace/app/views/authors/components/Carousel.jsx");
import(/* webpackMode: "eager" */ "/workspace/app/views/brands/components/Carousel.jsx");
import(/* webpackMode: "eager" */ "/workspace/app/views/Hero/components/Hero.jsx");
import(/* webpackMode: "eager" */ "/workspace/app/views/popular/components/Carousel.jsx");
import(/* webpackMode: "eager" */ "/workspace/components/ui/separator.jsx");
import(/* webpackMode: "eager" */ "/workspace/node_modules/next/dist/client/image-component.js");
import(/* webpackMode: "eager" */ "/workspace/node_modules/next/dist/client/link.js")